import axios from "axios";

export function validateAPI(action) {
  const code = action.code;
  const email = action.email;

  const metaData = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  return new Promise((resolve) => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND}/verify`,
        { email: email, code: code },
        metaData
      )
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        resolve(error.response.data)
      });
  });
}
